"use strict";

/**
 * Dispatcher central de eventos canónicos GA4/GTM para el feature
 * de sucursal/método de entrega. Punto único de armado de payload — evita
 * que cada trigger arme su propio shape ad hoc, con riesgo de nombres
 * inconsistentes o campos faltantes.
 *
 * Sin duplicados, es responsabilidad del LLAMADOR — esta función
 * no tiene memoria de qué se disparó antes. Cada punto de llamada tiene
 * que invocarse una sola vez, en el momento exacto donde el trigger se
 * completa de verdad (éxito del AJAX/confirmación real), nunca en
 * re-renders, callbacks repetidos, cierre de modal sin confirmar, o
 * refresh parcial del carrito.
 *
 * @param {string} eventName - nombre canónico exacto, snake_case
 * @param {Object} fields - campos propios del evento + los comunes que
 *   el llamador ya tenga a mano (surface/source/selected_store/
 *   delivery_method casi siempre hay que pasarlos explícitos, ya que
 *   varían por contexto y este dispatcher no los puede inferir solo)
 * @returns {void}
 */
function pushCanonicalEvent(eventName, fields) {
    var $brandInput = $('[name="siteBrand"]');
    var $userStateInput = $('[name="userState"]');

    var basePayload = {
        event: eventName,
        schema_version: "1.0.0",
        surface: null,
        source: null,
        brand: $brandInput.length ? $brandInput.val() : null,
        user_state: $userStateInput.length ? $userStateInput.val() : null,
        selected_store: null,
        delivery_method: null,
    };

    var payload = $.extend({}, basePayload, fields || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
}

/**
 * Arma el shape mínimo de selected_store que pide el contrato —
 * {id, name, city, province} — a partir de los distintos shapes de
 * sucursal que ya circulan en el código.
 *
 * @param {Object|null} store - {ID, name, city, ...} o null
 * @returns {Object|null}
 */
function toStorePayload(store) {
    if (!store) {
        return null;
    }

    return {
        id: store.ID || store.id || null,
        name: store.name || null,
        city: store.city || null,
        province: store.province || null,
    };
}

/**
 * Actualiza los hidden inputs globales del header
 * (checkoutDeliveryMethod / selectedStoreId / selectedStoreName /
 * selectedStoreCity) para que reflejen el estado real inmediatamente
 * después de un cambio.
 *
 * @param {string|null} deliveryMethod - null para limpiar
 * @param {Object|null} store - {ID, name, city} o null si no aplica/se limpió
 * @returns {void}
 */
function updateGlobalDeliveryState(deliveryMethod, store) {
    $('[name="checkoutDeliveryMethod"]').val(deliveryMethod || "");
    $('[name="selectedStoreId"]').val(store ? store.ID || store.id || "" : "");
    $('[name="selectedStoreName"]').val(store ? store.name || "" : "");
    $('[name="selectedStoreCity"]').val(store ? store.city || "" : "");
    $('[name="selectedStoreState"]').val(store ? store.province || "" : "");
}

module.exports = {
    pushCanonicalEvent: pushCanonicalEvent,
    toStorePayload: toStorePayload,
    updateGlobalDeliveryState: updateGlobalDeliveryState,
};